import script from "./EncounterNote.vue?vue&type=script&setup=true&lang=js"
export * from "./EncounterNote.vue?vue&type=script&setup=true&lang=js"

import "./EncounterNote.vue?vue&type=style&index=0&id=5abde58d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5abde58d"]])

export default __exports__